<template>
  <button
    class="rounded-full inline-flex  p-1 border border-solid"
    :class="active?'border-red-100':'border-white'"
  >
    <span
      class="text-transparent h-10 w-10 md:h-10 md:w-10 justify-center items-center relative rounded-full flex"
      :style="{ background: color }"
    >+</span>
</button>
</template>

<script>
export default {
  name: "Swatch",
  props: ["color", "currentColor", "active"],
  data() {
    return {
      // active:false
      // color: false,
    };
  },
  updated() {},
  computed: {
    swatchColor() {
      if (this.value == false) {
        return "#ffffff";
      } else {
        return this.value;
      }
    },
  },
  methods: {
    handleClick() {
      if (this.value == false || this.value == "" || this.value == undefined) {
        console.log(this.currenColor);
        this.value = this.currenColor;
      } else {
        this.emitColour();
      }
    },
    emitColour() {
      this.$emit("emitColour", this.value, this.key);
    },
  },
  mounted() {
    this.value = this.color;
  },
};
</script>
<style>
.hilite {
  /* top:-.25rem;
left:-.25rem; */
}
</style>
